import React, { useState, useEffect, useMemo } from "react";
import DeleteForm from "./DeleteForm.js";
import LoaderContainer from "../../../../Reusable/LoaderContainer/LoaderContainer.js";
import DuplicateForm from "./DuplicateForm.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import config from "config";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import HeaderItem from "./HeaderItem.js";
import bytesToDisplayHelper from "../../../../../utils/bytesToDisplayHelper.js";
import Tooltip from "../../../../Elements/Tooltip/Tooltip.js";
import GetFormScript from "./GetFormScript.js";
import EmbedDynamicExample from "components/Pages/EditEmbedPage/EditEmbedPageContent/EditEmbedPageBody/EmbedDynamicExample.js";
import parse from "html-react-parser";
import Image from "components/Elements/Image/Image.tsx";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { Toggle } from "../../../../Elements/Toggle/Toggle.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useToasts } from "react-toast-notifications";

const DynamicEmbedForm = ({
  i,
  form,
  userData,
  setDynamicFormsList,
  dynamicFormsList,
  loadingFormId,
  setLoadingFormId,
  setIsUpdateFormList,
  embedPageUserName,
}) => {
  const { addToast } = useToasts();
  const [isFocus, setIsFocus] = useState(false);
  const { isPremium } = useUser();
  //GetEmbedDynamicMailsStorage
  //Header icons
  const headerListItems = [
    {
      itemName: "search",
      tooltipTextKey: "jumboforms-preview-tooltip",
      iconName: "search-forms-management",
      itemFunction: () =>
        setModal({
          modal: EmbedDynamicExample,
          modalSize: "full-modal",
          //container: DefaultContainerNoClose,
          props: {
            selectedForm: form,
            previewMode: true,
          },
        }),
    },
    {
      itemName: "pencil",
      tooltipTextKey: "jumboforms-edit-tooltip",
      iconName: "pencil-alt-solid",
    },
    {
      itemName: "list",
      tooltipTextKey: "jumboforms-reports-tooltip",
      iconName: "reports",
    },
    {
      itemName: "copy",
      tooltipTextKey: "jumboforms-duplicate-tooltip",
      iconName: "copy-solid",
      itemFunction: () =>
        form.IsPickerForm
          ? addToast(getTextByKey("picker-form-actions-modal-text"), {
              appearance: "error",
            })
          : setModal(() => (
              <DuplicateForm
                formId={form.Embed_Dynamic_Id}
                culture={getLanguageCulture()}
                dynamicFormsList={dynamicFormsList}
                setDynamicFormsList={setDynamicFormsList}
                setLoadingFormId={setLoadingFormId}
              />
            )),
    },
    {
      itemName: "code",
      tooltipTextKey: "jumboforms-code-tooltip",
      iconName: "code-forms-management",
      itemFunction: () =>
        form.IsPickerForm
          ? addToast(getTextByKey("picker-form-actions-modal-text"), {
              appearance: "error",
            })
          : setModal(() => <GetFormScript userData={userData} form={form} />),
    },
    {
      itemName: "trash",
      tooltipTextKey: "jumboforms-delete-form-tooltip",
      iconName: "trash-solid-b",
      itemFunction: () =>
        form.IsPickerForm
          ? addToast(getTextByKey("picker-form-actions-modal-text"), {
              appearance: "error",
            })
          : setModal(() => (
              <DeleteForm
                formId={form.Embed_Dynamic_Id}
                emailsCount={form.Embed_Dynamic_MailsCount}
                setDynamicFormsList={setDynamicFormsList}
                setLoadingFormId={setLoadingFormId}
                setIsUpdateFormList={setIsUpdateFormList}
              />
            )),
    },
  ];

  const { getTextByKey, getPath, getLanguageCulture } = useContent();
  const { setModal } = useModal();
  const [startActiveForm, setStartActiveForm] = useState(
    form.Embed_Dynamic_Live_Status
  );
  const [allRecipients, setAllRecipients] = useState(null);
  const [firstRecipient, setFirstRecipient] = useState(null);
  const [countRecipients, setCountRecipients] = useState(0);
  const [activeForm, setActiveForm] = useState(form.Embed_Dynamic_Live_Status);
  const [openScript, setOpenScript] = useState(null);
  const [openModel, setOpenModel] = useState(false);
  const [showIconsHeaderInMobile, setShowIconsHeaderInMobile] = useState(false);

  //replace constText
  const replaceEmbedDynamicDeleteDays = (text, deleteDays) => {
    let newText = text.replaceAll("#DeleteDays#", deleteDays);
    return newText;
  };

  useEffect(() => {
    if (activeForm !== startActiveForm) {
      unActiveForm(form);
    }
  }, [activeForm]);

  const unActiveForm = async (form) => {
    setStartActiveForm(activeForm);
    const requestBody = {
      EmbedDynamicId: form.Embed_Dynamic_Id,
      FormStatus: activeForm,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "ChangeFormStatusReact",
      requestBody,
      "POST"
    );
    if (response.status === "success") {
    }
  };

  const embedPageUrl = (url) => {
    //if url not contain https:// add https://
    const correctUrl = url.includes("http") ? url : "https://" + url;
    return (
      <a href={correctUrl} target="_blank" rel="noopener noreferrer">
        {correctUrl}
      </a>
    );
  };

  const externalUrl = (url) => {
    // if url include http, return url else return https://url
    return url.includes("http") ? url : "https://" + url;
  };

  useMemo(() => {
    if (form) {
      setStartActiveForm(form.Embed_Dynamic_Live_Status);
      setActiveForm(form.Embed_Dynamic_Live_Status);
      if (form.Embed_Dynamic_Recipients) {
        if (form.Embed_Dynamic_Recipients.includes(",")) {
          setAllRecipients(form.Embed_Dynamic_Recipients);
          let temp = form.Embed_Dynamic_Recipients.split(",");
          setFirstRecipient(temp[0]);
          const count = (form.Embed_Dynamic_Recipients.match(/,/g) || [])
            .length;
          setCountRecipients(count);
        }
      } else {
        setFirstRecipient(form.Embed_Dynamic_Recipients);
      }
    }
  }, [form]);

  return (
    <>
      <div className={`form-item`} key={i}>
        {loadingFormId.some((item) => item === form.Embed_Dynamic_Id) ? (
          <LoaderContainer isLoading={false} />
        ) : (
          <>
            <div className="form-header">
              <div className="left">
                {form.Embed_Dynamic_Image && (
                  <div className="form-image">
                    <Image alt="" title="" src={form.Embed_Dynamic_Image} />
                  </div>
                )}
                <div className="form-details">
                  <h1>
                    {parse(form.Embed_Dynamic_Inner_Title)}{" "}
                    <span className="form-id">
                      (ID: {form.Embed_Dynamic_Id})
                    </span>
                  </h1>
                  {form.Embed_Dynamic_Description &&
                    (form.Embed_Dynamic_Description.length > 54 ? (
                      <Tooltip
                        clickable
                        id={"embed-form-description" + i}
                        tooltipText={parse(form.Embed_Dynamic_Description)}
                        //hardPositioned
                      >
                        <span className="description-span">
                          {parse(form.Embed_Dynamic_Description)}
                        </span>
                      </Tooltip>
                    ) : (
                      <span className="description-span">
                        {parse(form.Embed_Dynamic_Description)}
                      </span>
                    ))}
                </div>
              </div>
              <div className={`right ${isFocus ? "focus-div" : ""}`}>
                <ul className="">
                  {headerListItems.map((item, j) =>
                    !isPremium() && item.itemName === "code" ? null : (
                      <HeaderItem
                        isFocus={isFocus}
                        setIsFocus={setIsFocus}
                        openModel={openModel}
                        setOpenModel={setOpenModel}
                        key={j}
                        form={form}
                        i={i}
                        openScript={openScript}
                        setOpenScript={setOpenScript}
                        item={item}
                      />
                    )
                  )}
                </ul>
              </div>
              <div className="right-mobile">
                <span
                  onClick={() => {
                    setShowIconsHeaderInMobile((prev) => !prev);
                  }}
                >
                  <Icon name={"vertical-three-dots"} />
                </span>
              </div>
            </div>
            {showIconsHeaderInMobile ? (
              <ul className="icons-list">
                {headerListItems.map((item, j) =>
                  !isPremium() && item.itemName === "code" ? null : (
                    <HeaderItem
                      isFocus={isFocus}
                      setIsFocus={setIsFocus}
                      openModel={openModel}
                      setOpenModel={setOpenModel}
                      key={j}
                      form={form}
                      i={i}
                      openScript={openScript}
                      setOpenScript={setOpenScript}
                      item={item}
                    />
                  )
                )}
              </ul>
            ) : null}
            <div className="form-content">
              <div className="form-details">
                <div className="details-contents">
                  <p className="recipients">
                    <span className="text-title">
                      {getTextByKey("jumboforms-form-recipients")}
                    </span>
                    :
                    {allRecipients ? (
                      <Tooltip
                        className="recipients-tooltip"
                        //clickable
                        id={"embed-form-recipients-tooltip" + i}
                        tooltipText={form.Embed_Dynamic_Recipients}
                        //hardPositioned
                      >
                        <span className="recipients-span">
                          {firstRecipient}{" "}
                          <div className="count-recipients-div">
                            {" "}
                            <span className="count-recipients">
                              +{countRecipients}
                            </span>
                          </div>
                        </span>
                      </Tooltip>
                    ) : (
                      <span className="recipients-span">
                        {form.Embed_Dynamic_Recipients}
                      </span>
                    )}
                  </p>
                  <p>
                    <span className="text-title">
                      {getTextByKey("location")}
                    </span>
                    :{" "}
                    <div className="location-icons">
                      {form.IncludesInEmbedPage && (
                        <Tooltip
                          className="embed-url-tooltip"
                          clickable
                          id={"embed-page-website-tooltip" + i}
                          tooltipText={embedPageUrl(
                            config.baseurl + "/page/" + embedPageUserName
                          )}
                          //hardPositioned
                        >
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={config.baseurl + "/page/" + embedPageUserName}
                          >
                            <span className="website">
                              <Icon name={"website-forms-management"} />
                            </span>
                          </a>
                        </Tooltip>
                      )}
                      {form.Embed_Dynamic_Url && (
                        <Tooltip
                          className="embed-url-tooltip"
                          clickable
                          id={"embed-form-url-tooltip" + i}
                          tooltipText={embedPageUrl(form.Embed_Dynamic_Url)}
                          //hardPositioned
                        >
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={externalUrl(form.Embed_Dynamic_Url)}
                          >
                            <span>
                              <Icon name={"embeded"} />
                            </span>
                          </a>
                        </Tooltip>
                      )}
                    </div>
                  </p>
                  <p>
                    <span className="text-title">
                      {getTextByKey("jumboforms-storage-mails-size")}
                    </span>
                    :{" "}
                    {form.Embed_Dynamic_Manually_Delete &&
                    form.Embed_Dynamic_mailsTotalSize > 0
                      ? bytesToDisplayHelper(form.Embed_Dynamic_mailsTotalSize)
                          .size +
                        bytesToDisplayHelper(form.Embed_Dynamic_mailsTotalSize)
                          .type
                      : 0}
                  </p>
                  {!form.Embed_Dynamic_Manually_Delete ? (
                    <p>
                      <span className="text-title">
                        {getTextByKey("jumboforms-files-removal")}
                      </span>
                      :{" "}
                      {replaceEmbedDynamicDeleteDays(
                        getTextByKey("jumboforms-files-delete-days"),
                        form.Embed_Dynamic_Delete_Days
                      )}
                    </p>
                  ) : (
                    <p>
                      <span className="text-title">
                        {getTextByKey("jumboforms-files-removal")}
                      </span>
                      : {getTextByKey("jumboforms-delete-files-manually")}
                    </p>
                  )}
                </div>
                <div className="statistics-contents">
                  <div className="statistics-left-side">
                    <Tooltip
                      //clickable
                      id={"embed-form-orders-tooltip"}
                      tooltipTextKey={"form-management-orders-tooltip"}
                      //hardPositioned
                    >
                      <div className="statistic-item">
                        <Icon name="ordersForm" />
                        <p>
                          <span className="text-title">
                            {getTextByKey("jumboforms-total-received-orders")}:{" "}
                          </span>

                          {form.Statistic_Complete_Count
                            ? form.Statistic_Complete_Count
                            : "0"}
                        </p>
                      </div>
                    </Tooltip>
                    <Tooltip
                      //clickable
                      id={"embed-form-leads-tooltip"}
                      tooltipTextKey={"form-management-leads-tooltip"}
                      //hardPositioned
                    >
                      <div className="statistic-item">
                        <Icon name="leadsForm" />
                        <p>
                          <span className="text-title">
                            {getTextByKey("jumboforms-total-lead")}:{" "}
                          </span>

                          {form.Statistic_Lead_Count
                            ? form.Statistic_Lead_Count
                            : "0"}
                        </p>
                      </div>
                    </Tooltip>
                    <Tooltip
                      //clickable
                      id={"embed-form-views-tooltip"}
                      tooltipTextKey={"form-management-views-tooltip"}
                      //hardPositioned
                    >
                      <div className="statistic-item">
                        <Icon name="viewsForm" />
                        <p>
                          <span className="text-title">
                            {getTextByKey("jumboforms-total-views")}:{" "}
                          </span>

                          {form.Statistic_View_Count
                            ? form.Statistic_View_Count
                            : "0"}
                        </p>
                      </div>
                    </Tooltip>
                  </div>
                  <div className="statistics-right-side">
                    <Toggle status={activeForm} setStatus={setActiveForm} />
                    <span>{getTextByKey("turn-on")}</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default DynamicEmbedForm;
